import React from "react";

// Phone mockup wrapping a REAL screenshot of the platform.
export function PhoneFrame({ src, alt, className = "", testid }) {
  return (
    <div className={`relative mx-auto w-[220px] sm:w-[250px] aspect-[9/18.5] rounded-[2.4rem] bg-[#0c2d34] p-[9px] shadow-[0_30px_60px_-25px_rgba(12,45,52,0.55)] ${className}`} data-testid={testid}>
      <div className="absolute top-[14px] left-1/2 -translate-x-1/2 h-[18px] w-[80px] rounded-full bg-[#0c2d34] z-10" />
      <div className="h-full w-full rounded-[1.9rem] overflow-hidden bg-[#f6f7f5]">
        <img src={src} alt={alt} className="h-full w-full object-cover object-top" loading="lazy" decoding="async" />
      </div>
    </div>
  );
}

// Browser-like frame for dashboard screenshots.
export function BrowserFrame({ src, alt, className = "", testid }) {
  return (
    <div className={`rounded-2xl border border-border bg-white overflow-hidden shadow-[0_30px_60px_-28px_rgba(12,45,52,0.45)] ${className}`} data-testid={testid}>
      <div className="h-8 bg-[#f1f4f3] border-b border-border flex items-center gap-1.5 px-3">
        <span className="h-2.5 w-2.5 rounded-full bg-[#dfe5e3]" /><span className="h-2.5 w-2.5 rounded-full bg-[#dfe5e3]" /><span className="h-2.5 w-2.5 rounded-full bg-[#dfe5e3]" />
        <span className="ml-3 h-4 flex-1 max-w-[260px] rounded-md bg-white border border-border" />
      </div>
      <img src={src} alt={alt} className="w-full h-auto block" loading="lazy" decoding="async" />
    </div>
  );
}
